export const MOTION_CONFIG = {
  /** Kill switch for Lenis smooth scrolling. Every effect also works on native scroll. */
  smoothScroll: true,
  /** px, matches the --nav-h CSS variable. */
  navHeight: 75,
  refreshDebounceMs: 120,
  langSwitchWindowMs: 1200,
} as const;
